import { useEffect } from "react";
// Import Global Contexts
import { useCalculatorContext } from '../contexts/CalculatorContext';
// Import Functions
import formatToMoney from "./../functions/formatToMoney";
import formatToMoneyInput from "./../functions/formatToMoneyInput";
import { isValidNumber, menuBar } from "./../functions/generalFunctions";
//Import Assets
import { faCheckSquare, faSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import jahLogo from './../assets/images/logo-jah.svg';
import CurrencySelect from "./CurrencySelect";


const Calculator = () => {

    // Use the Global Calculator Context 
    const {
        fob, setFob,
        flete, setFlete,
        tax, setTax,
        subtotal, setSubtotal,
        extraExpenses, setExtraExpenses,
        extraExpensesCheck, setExtraExpensesCheck,
        operationalExpenses, setOperationalExpenses,
        operationalExpensesCheck, setOperationalExpensesCheck,
        totalInsured, setTotalInsured,
        rate, setRate,
        minPremium, setMinPremium,
        premium, setPremium,
        history, setHistory,
        setActivePremium,
        getPremiumValue,
        currency, setCurrency
    } = useCalculatorContext();

    // Function to handle the inputs changes
    const handleOnChange = (e) => {

        const formattedValue = formatToMoneyInput(e.target.value); // Separador de Miles

        switch (e.target.name) {
            case "fob_value":
                setFob(formattedValue);
                break;
            case "flete_value":
                setFlete(formattedValue);
                break;
            case "tax_value":
                setTax(formattedValue);
                break;
            case "rate_value":
                setRate(formattedValue);
                break;
            case "mp_value":
                setMinPremium(formattedValue);
                break;
            default:
                // Do nothing
                break;
        }
    };

    // Function to handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Get Premium Value
        const result = getPremiumValue();
        if (!result) return;

         // Actualizamos los estados solo para visualización
        setSubtotal(result.subtotal);
        setExtraExpenses(result.extraExpenses);
        setOperationalExpenses(result.operationalExpenses);
        setTotalInsured(result.totalInsured);
        setPremium(result.premium);

        // Update History
        setHistory(  
            [
                ...history, {
                    id: history.length + 1,
                    fob: fob,
                    flete: flete,
                    tax: tax,
                    extraExpensesCheck: extraExpensesCheck,
                    operationalExpensesCheck: operationalExpensesCheck,
                    rate: rate,
                    minPremium: minPremium,
                    subtotal: result.subtotal,
                    extraExpenses: result.extraExpenses,
                    operationalExpenses: result.operationalExpenses,
                    totalInsured: result.totalInsured,
                    premium: result.premium,
                    currency
                }
            ]
        );

        // Update the active Premium ID
        setActivePremium(history.length + 1)
    };

    // Function to clear all the form fields
    const clearForm = (e) => {

        // Reset all 
        setFob('');
        setFlete('');
        setTax('');
        setSubtotal('0');
        setExtraExpenses('0');
        setExtraExpensesCheck(false);
        setOperationalExpenses('0');
        setOperationalExpensesCheck(false);
        setTotalInsured('0');
        setRate('');
        setMinPremium('');
        setPremium(0);
        setCurrency()
    }

    useEffect(() => {
        // Checking for URL Parameters
        const params = new URLSearchParams(window.location.search);

        const queryObject = {};
        for (const [key, value] of params.entries()) {
            queryObject[key] = value;
        }

        // Validar que el valor Fob y la Tarifa no sean nulos
        if(isValidNumber(queryObject.fob) && isValidNumber(queryObject.premium)) { 
             console.log("The Premim Params are valid ");
            /* Setting Premium Params */
            // Shipment Value
            setFob(formatToMoneyInput(queryObject.fob));
            // Freight
            if(isValidNumber(queryObject.flete)) { 
                setFlete(formatToMoneyInput(queryObject.flete));
            }
            // Customs Taxes
            if(isValidNumber(queryObject.tax)) { 
                setTax(formatToMoneyInput(queryObject.tax));
            }
            if(isValidNumber(queryObject.subtotal)) { 
                setSubtotal(queryObject.subtotal);
            }
            if(queryObject.extraExpensesCheck === 'true') { 
                setExtraExpensesCheck(true);
            }
            if(isValidNumber(queryObject.extraExpenses)) { 
                setExtraExpenses(queryObject.extraExpenses);
            }
            if(queryObject.operationalExpensesCheck === 'true') { 
                setOperationalExpensesCheck(true);
            }
            if(isValidNumber(queryObject.operationalExpenses)) { 
                setOperationalExpenses(queryObject.operationalExpenses);
            }
            if(isValidNumber(queryObject.totalInsured)) { 
                setTotalInsured(queryObject.totalInsured);
            }
            if(isValidNumber(queryObject.rate)) { 
            setRate(queryObject.rate);
            }
            if(isValidNumber(queryObject.minPremium)) { 
                setMinPremium(queryObject.minPremium);
            }
            setPremium(queryObject.premium)
        }
    }, [
        setExtraExpenses, setExtraExpensesCheck,
        setFlete, setFob, setMinPremium, setOperationalExpenses,
        setOperationalExpensesCheck, setPremium, setRate,
        setSubtotal, setTax, setTotalInsured
    ]);

    return ( 
        <form action="" className="main" onSubmit={handleSubmit}>
            <header className="header-app">
                <button type="button" id="btnMenu" className="menu-bar btnMenu" onClick={()=> menuBar()} aria-label="Main Menu">
                    <svg width="100" height="100" viewBox="0 0 100 100">
                        <path className="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
                        <path className="line line2" d="M 20,50 H 80" />
                        <path className="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
                    </svg>
                </button>
                <div className="top">
                    <a className="logo-jah" href="https://www.jahinsurance.com/" target="_blank" rel="noreferrer">
                        <img src={jahLogo}  alt="Logo JAH Insurance Brokers"/>
                    </a>
                    <div className="btn-wrap">
                    <button type="submit" className="btn accent">Calcular</button>
                    <button type="button" className="btn" onClick={(e)=> clearForm(e)}>Borrar</button>
                    </div>
                    
                </div>
                <div className="bottom">
                    <h1>Calculadora de Prima</h1>
                    <h2>Prima o costo del certificado de seguro</h2>
                    <p className="prima-result">{ formatToMoney(premium, currency) }</p>
                </div>
            </header>

            <main className="body-app">
                <div className="top">
                    <h2>Concepto</h2>
                    <h2>Valor (<CurrencySelect />)</h2>
                </div>

                <div className="form-app">
                    <div className="wrap-fields">
                        <label className="label" htmlFor="fob_value">Valor FOB</label>
                        <input className="input" id="fob_value" type="text" name="fob_value" autoComplete="off"  
                            value={fob}
                            onChange={handleOnChange}
                        />
                    </div>

                    <div className="wrap-fields">
                        <label className="label" htmlFor="flete_value">Flete</label>
                        <input className="input" id="flete_value" type="text" name="flete_value" autoComplete="off"  
                            value={flete}
                            onChange={handleOnChange}
                        />
                    </div>

                    <div className="wrap-fields">
                        <label className="label" htmlFor="tax_value">Impuestos Arancelarios</label>
                        <input className="input" id="tax_value" type="text" name="tax_value" autoComplete="off"  
                            value={tax}
                            onChange={handleOnChange}
                        />
                    </div>

                    <div className="wrap-fields">
                        <p className="label">Subtotal</p><p className="result" id="subtotal_result">{formatToMoney(subtotal)}</p>
                    </div>

                    <div className="wrap-fields">
                        <button className="btn-label" onClick={() => setExtraExpensesCheck(!extraExpensesCheck)}>
                            <FontAwesomeIcon icon={(extraExpensesCheck) ? faCheckSquare : faSquare}/> 
                            Gastos Adicionales (10%)
                        </button>
                        <p className="result" id="additionalCheck">{formatToMoney(extraExpenses)}</p>
                    </div>

                    <div className="wrap-fields">
                        <button className="btn-label" onClick={() => setOperationalExpensesCheck(!operationalExpensesCheck)}>
                            <FontAwesomeIcon icon={(operationalExpensesCheck) ? faCheckSquare : faSquare}/> 
                            Gastos Operativos (10%)
                        </button>
                        <p className="result" id="operativesCheck">{formatToMoney(operationalExpenses)}</p>
                    </div>

                    <div className="wrap-fields">
                        <p className="label">Valor Asegurado Total</p>
                        <p className="result" id="total_insured_result">{formatToMoney(totalInsured)}</p>
                    </div>

                    <div className="wrap-fields">
                        <label className="label" htmlFor="rate_value">Tarifa (%)</label>
                        <input className="input" id="rate_value" type="text" name="rate_value" autoComplete="off"  
                            value={rate}
                            onChange={handleOnChange}
                        />
                    </div>

                    <div className="wrap-fields">
                        <label className="label" htmlFor="mp_value">Prima Mínima de Venta</label>
                        <input className="input" id="mp_value" type="text" name="mp_value" autoComplete="off"  
                            value={minPremium}
                            onChange={handleOnChange}
                        />
                    </div>
                </div>
            </main>
        </form>
    );
}
 
export default Calculator;